import { FC, lazy, memo, PropsWithChildren, Suspense } from "react";

import { useReactiveVar } from "@apollo/client";
import { LoadingPage } from "@hl/base-components/lib/LoadingPage";
import { useInitState } from "@hl/shared-features/lib/features/auth/hooks";

import { modalVar, ModalType } from "./Modal/modal";

const ChangeGateModal = lazy(
  () => import("~/features/manage-collection/modals/ChangeGateModal")
);
const SaleAvailabilityModal = lazy(
  () =>
    import(
      "~/features/manage-collection/mint-vector/modals/SaleAvailabilityModal"
    )
);
const EmbedGatedPageModal = lazy(
  () => import("~/features/manage-collection/modals/EmbedGatedPageModal")
);
const GatedEntityAllPrereqsModal = lazy(
  () => import("~/features/pages/GatedEntityAllPrereqsModal")
);

const Root: FC<PropsWithChildren> = ({ children }) => {
  const isReady = useInitState();
  const { showModal } = useReactiveVar(modalVar);

  if (!isReady) {
    return <LoadingPage />;
  }

  return (
    <>
      {children}
      <Suspense fallback={""}>
        {showModal === ModalType.EMBED_GATE_PAGE && <EmbedGatedPageModal />}
        {showModal === ModalType.SALE_AVAILABILITY && <SaleAvailabilityModal />}
        {showModal === ModalType.CHANGE_GATE && <ChangeGateModal />}
        {showModal === ModalType.GATED_ENTITY_ALL_PREREQS && (
          <GatedEntityAllPrereqsModal />
        )}
      </Suspense>
    </>
  );
};

export default memo(Root);
